import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { updateComponent, fetchData } from '../../state/actions/componentsActions'
import { connect } from 'react-redux'
import { FetchPromoCode,FetchPOSPlan } from '../../state/api'
import { css, withStyles } from '../../styles/withStyles'
import Styles from './styles'
import MobileDetect from 'mobile-detect'

class Label extends Component {
  constructor(props) {
    super(props)
  }
  componentDidMount() {
    if (this.props.component.name === "S16S1D2") {
      const { component, dispatch } = this.props
      let body = component.fetchPromoCode.body
      let url = component.fetchPromoCode.url
      FetchPromoCode(url, body).then(json => {
        if (!!json.payLoad && json.payLoad.PromoCode === 'TRYBLACK') {
          dispatch(updateComponent(component.id, {status: []}))
        } else {
          dispatch(updateComponent(component.id, {status: ['hidden']}))
        }

      })
    }
    if(this.props.component.id==="POSPLAN-PLAN")
    {
      const { component, dispatch } = this.props
      let body=component.fetchPosPlan.body
      let url=component.fetchPosPlan.url
      FetchPOSPlan(url,body).then(json=>{
        if(json && json.payLoad && json.payLoad.Plan) {
          dispatch(updateComponent(component.id, { value: json.payLoad.Plan}))
        }
      })
    }
  }

  render() {
    const { widget, component } = this.props
    const md = new MobileDetect(window.navigator.userAgent)

    return (
      this.props.component.id==='S1-S1S4D7'?
      <div>
      <h4 {...css(this.props.styles['widget-group__title'])}
      dangerouslySetInnerHTML={{ __html: 'Contatti utente amministratore Dashboard'}}></h4>
      <span><small dangerouslySetInnerHTML={{ __html: 'Indicare i dati dell’utente amministratore Dashboard che gestisce le associazioni degli utenti ai terminali POS tramite la Fabrick Dashboard.' }}></small></span>
      </div>
      :
      <p
        {...css(
          this.props.styles.component,
          this.props.styles['component--block'],
          this.props.styles.label,
          component.status[0] === 'hidden' ? this.props.styles['component--hidden'] : '',
          !!this.props.component.isSmall && this.props.styles['label--small'],
          !!this.props.component.isPadded && this.props.styles['label--padded'],
          !!this.props.component.isCentered && this.props.styles['label--centered'],
          !!this.props.component.isBold && this.props.styles['label--bold'],
          !md.mobile() && !!this.props.component.id && this.props.component.id === 'PEC-ADDRESS' ? this.props.styles['label--align'] : ''
        )}
        dangerouslySetInnerHTML={{ __html: component.value }}
      >
      </p>
    )
  }

}

Label.propTypes = {
  widget: PropTypes.object.isRequired,
  component: PropTypes.object.isRequired,
  styles: PropTypes.object.isRequired
}

const mapStateToProps = () =>{
  return {}
}

export default connect(mapStateToProps)(withStyles(Styles)(Label))



// WEBPACK FOOTER //
// ./components/label/index.js